import PageHero from '../components/PageHero'
import Reveal from '../components/Reveal'
import SectionHeading from '../components/SectionHeading'
import { achievements } from '../data/career'
import { site } from '../data/site'
import { useSeo } from '../hooks/useSeo'

export default function AboutPage() {
  useSeo({
    title: 'About Em | Em Whell Motorsport',
    description: "Meet Em Whell — a young Queensland driver who started racing at 14 and now competes in SSA Production Sedans out of Toowoomba.",
    path: '/about',
    image: '/assets/em-portrait.jpg',
  })

  return (
    <>
      <PageHero eyebrow="About Em" title="Driven to" highlight="progress." copy="A young Queensland driver building experience, confidence and results one race at a time." image="/assets/em-portrait.jpg" imageWidth={1080} imageHeight={1920} position="center 20%" />
      <section className="section">
        <div className="site-container editorial-grid">
          <Reveal className="profile-panel">
            <img src="/assets/em-whell-logo.png" alt="Em Whell Motorsport" width="1200" height="231" loading="lazy" />
            <dl>
              <div><dt>Driver</dt><dd>{site.driver}</dd></div>
              <div><dt>Number</dt><dd>#{site.number}</dd></div>
              <div><dt>Class</dt><dd>{site.className}</dd></div>
              <div><dt>Based</dt><dd>{site.location}</dd></div>
              <div><dt>Racing since</dt><dd>2019</dd></div>
            </dl>
          </Reveal>
          <Reveal className="editorial">
            <p className="lead">Em Whell is the driver of the #7 SSA Production Sedan, proudly based in Toowoomba, Queensland.</p>
            <p>Em started racing in 2019 at 14 years old, beginning in Junior Sedans behind the wheel of a Daihatsu Charade. After her first season, the family built a Mitsubishi Mirage that Em raced for another two years.</p>
            <p>Across those three junior seasons, Em collected race wins, consistent podiums and strong finishes at local and Blue-Ribbon events. She wrapped up her junior years with fifth place in the Junior Sedan All Star Series and the Junior Sedan Top Star Club Champion title.</p>
            <p>Em’s parents have been her mentors and teachers across motorsport and everyday driving technique. Their guidance has played a major role in shaping the driver she is today.</p>
            <p>In 2023, Em moved into the senior division and made her debut in SSA Production Sedans. The step brought new challenges and valuable lessons. With more seat time and support from experienced drivers, she built confidence and consistency across the 2023–2024 and 2024–2025 seasons.</p>
          </Reveal>
        </div>
      </section>
      <section className="section section-dark">
        <div className="site-container">
          <SectionHeading eyebrow="Career highlights" title="Earned through" highlight="experience." />
          <div className="achievement-grid">{achievements.map((achievement, index) => <Reveal key={achievement}><div><span>{String(index + 1).padStart(2, '0')}</span><strong>{achievement}</strong></div></Reveal>)}</div>
        </div>
      </section>
      <section className="split-image-section">
        <img src="/assets/img_about_02.jpg" alt="Em Whell at a Production Sedan podium presentation" width="1600" height="1200" loading="lazy" />
        <div><Reveal><p className="eyebrow">The support behind the driver</p><h2>Family. Mentors. <span>Team.</span></h2><p>Motorsport is never a solo effort. Em’s progress is supported by family, fellow competitors, partners and everyone who helps prepare the #7 for the next race.</p></Reveal></div>
      </section>
    </>
  )
}
